<p-toast></p-toast>
<!-- <div class="card"> -->
<div class="card mt-2 personal-details-card">
  <h5
    [ngStyle]="{ 'font-weight': 'bold','display': 'flex', 'justify-content': 'space-around', 'color': 'rgb(151, 42, 42)' }">
    {{ "REGISTRATION_DETAILS" | translate }}
    <!-- <span [ngStyle]="{ color: 'rgb(151, 42, 42)', 'font-weight': 'bold' }">{{
        vendorFormData?.Mobile
      }}</span> -->
  </h5>
  <!-- <form [formGroup]="basicDetailsForm"> -->
  <div class="sec-1">
    <div class="p-fluid p-formgrid grid mt-3 px-2">
      <div class="field col-12 md:col-12 sub-heading">
        <p>{{ "BASIC_INFORMATION" | translate }}</p>
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="Vendor_TypeId">{{ "REGISTRATION_TYPE" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Vendor_TypeId }}" pInputText id="Vendor_TypeId"
          type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="SupManNames">{{ "MANUFACTURER_SUBMANU" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.SupManNames }}" pInputText id="SupManNames"
          type="text" />
      </div>
      <div class="field col-12 md:col-4">
        <label htmlFor="Email_ID">{{ "OFFICIAL_EMAIL_ID" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Officical_Email_ID }}" pInputText id="Email_ID"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Mobile">{{ "Mobile" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Mobile }}" pInputText id="Mobile" type="text" />
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="VendorName">{{ "NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Vendor_Name }}" pInputText id="VendorName"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DOI">{{ "DATE_OF_INCORPORATION" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DOI }}" pInputText id="DOI" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="GST_No">{{ "GST_NO" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.GST_No }}" pInputText id="GST_No" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Address">{{ "ADDRESS" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Address }}" pInputText id="Address" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="City">{{ "CITY" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.City }}" pInputText id="City" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="State">{{ 'STATE' | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.State }}" pInputText id="State" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Country">{{ 'COUNTRY' | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Country }}" pInputText id="Country" type="text" />
      </div>
    </div>
  </div>


  <div class="sec-2">
    <div class="p-fluid p-formgrid grid mt-3 px-2">
      <div class="field col-12 md:col-12 sub-heading">
        <p>{{ "BANK_DETAILS" | translate }}</p>
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="TAN_No">{{ "TAN_NO" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.TAN_No }}" pInputText id="TAN_No" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="PAN_No">{{ "PAN_NUMBER" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.PAN_No }}" pInputText id="PAN_No" type="text" />
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="Account_No">{{ "ACCOUNT_NUMBER" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Account_No }}" pInputText id="Account_No"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="IFSC_Code">{{ "IFSC_CODE" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.IFSC_Code }}" pInputText id="IFSC_Code"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="Bank_Name">{{ "BANK_NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Bank_Name }}" pInputText id="Bank_Name"
          type="text" />
      </div>

    </div>
  </div>

  <div class="sec-1">
    <div class="p-fluid p-formgrid grid mt-3 px-2">
      <div class="field col-12 md:col-12 sub-heading">
        <p>{{ 'REGISTRATION_FEES' | translate }}</p>
      </div>

      <div class="field col-12 md:col-3">
        <label htmlFor="Amount">{{ "DD_AMOUNT" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.Amount }}" pInputText id="Amount" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DDNumber">{{ "DD_NUMBER" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DDNumber }}" pInputText id="DDNumber" type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DDBankName">{{ "BANK_NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DDBankName }}" pInputText id="DDBankName"
          type="text" />
      </div>
      <div class="field col-12 md:col-3">
        <label htmlFor="DD_Date">{{ "DD_DATE" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DD_Date | date:'mediumDate' }}" pInputText
          id="DD_Date" type="text" />
      </div>
      <div class="field col-12 md:col-12">
        <label htmlFor="DDProgNames">{{ "PROGRAMME_NAME" | translate }}</label>
        <input class="readonly" readonly value="{{ vendorFormData?.DDProgNames }}" pInputText id="DDProgNames"
          type="text" />
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- </form> -->

  <div class="card mt-2 attachment-card">
    <div class="field col-12 md:col-12 sub-heading">
      <p>{{ 'ATTACHMENT_DETAILS' | translate }}</p>
    </div>
    <!-- <h5
        [ngStyle]="{ 'font-weight': 'bold', 'display': 'flex', 'justify-content': 'space-around', 'color': 'rgb(151, 42, 42)' }">
        {{ "ATTACHMENT_DETAILS" | translate }}
      </h5> -->
    <div class="p-fluid p-formgrid grid d-flex justify-content-between grid mt-1">
      <!-- <div class="document-list gap-1" style="display: flex; flex-wrap: wrap;"> -->
      <div class="field col-12 md:col-3" *ngFor="let item of vendorAttachmentData; let i = index">
        <!-- <div class="field col-12 md:col-3"> -->
        <label>{{ item.Doc_Type | translate }}</label>
        <p *ngIf="item.Attachments">
          <a style="cursor: pointer" [href]="item.Attachments" target="_blank">{{ 'View Doc' | translate }}</a>
        </p>

        <!-- </div> -->
      </div>
      <p class="invalid-feedback" *ngIf="vendorAttachmentData && vendorAttachmentData.length < 1">
        {{ imageError }}
      </p>
      <!-- </div> -->

    </div>
    <div *ngIf="vendorAttachmentData && vendorAttachmentData.length > 0" class="d-flex justify-content-center">
      <!-- <p-button icon="pi pi-bell" [rounded]="true" severity="warning" [outlined]="true"></p-button> -->
      <!-- <p-button label="Danger" [text]="true" severity="danger"></p-button> -->
      <!-- <button type="button" class="btn btn-warning">Warning</button> -->
      <button pButton pRipple label="{{ 'EDIT' | translate }}" class="p-button-danger text-md" style="width: auto;" (click)="onClickDocEdit()"></button>
      <!-- <p-button icon="pi pi-edit" label="{{ 'EDIT' | translate }}" severity="warning" class="p-button-danger"
        (click)="onClickDocEdit()"></p-button> -->
    </div>
  </div>
</div>

<p-dialog header="Edit Supporting Document" [baseZIndex]="-101" [(visible)]="showDocEditDialog" [modal]="true"
  [style]="{width: '90%', height:'60%'}" [maximizable]="true" [draggable]="false" [resizable]="false"
  (onHide)="onCloseDocDialog()">
  <form [formGroup]="vendorForm">
    <div class="p-fluid p-formgrid justify-content-center edit-supp-document" style="display: flex; flex-wrap:wrap">
      <!-- Document Type Dropdown -->
      <div class="field col-12 md:col-4">
        <label for="documentType">Document Type</label>
        <!-- <p-dropdown id="documentType" [options]="vendorAttachmentData" formControlName="documentType" -->
          <!-- optionLabel="Doc_Type" placeholder="Select Document Type" [showClear]="true"> -->
        <p-dropdown id="documentType" [options]="uploadOptions" formControlName="documentType"
          optionLabel="DocType" placeholder="Select Document Type" [showClear]="true">
        </p-dropdown>
        <div *ngIf="vendorForm.get('documentType').invalid && vendorForm.get('documentType').touched" class="error">
          <small *ngIf="vendorForm.get('documentType').errors?.['required']">Document Type is required.</small>
        </div>
      </div>

      <!-- File Upload -->
      <div class="field col-12 md:col-4">
        <label for="fileUpload">Upload Document</label>
        <p-fileUpload accept=".pdf" #grievanceCopyPath [customUpload]="true"
          [disabled]="vendorForm.invalid || vendorForm.get('documentType').invalid"
          (uploadHandler)="onUpload($event, 'grievanceCopyPath', grievanceCopyPath)" name="myfile[]" mode="basic"
          [maxFileSize]="5000000" cho oseLabel="Browse" [auto]="true">
        </p-fileUpload>
      </div>

      <div class="field col-12 md:col-12">
        <div class="document-list" style="display: flex; flex-wrap:wrap;">
          <!-- <label for="description">Document Updated Successfully</label> -->
          <div class="field col-12 md:col-12 document p-fluid p-formgrid grid mt-2" *ngFor="let item of documentList; let i=index">
            <div class="mr-2 px-2 py-2 update-doc-box">
              <span>
                <br>
                <p style="margin-bottom: 0;" target="_blank" class="mx-4"> {{item.documentType ? item.documentType:
                  item.DocumentType}} Updated Successfully.</p>
                <!-- <i class="pi pi-times cross-icon" style="color: red; cursor: pointer;"
                  (click)="removeCaptureImg(i)"></i> -->
                <!-- </span> -->
                <img *ngIf="isImage(item.attachmentsDoc || item.ImagePath); else pdfTemplate"
                  [src]="item.attachmentsDoc ? item.attachmentsDoc : item.ImagePath"
                  style="max-width: 300px; max-height: 300px; display: block;">
                <p *ngIf="isImage(item.attachmentsDoc || item.ImagePath)">
                  <a style="cursor: pointer" [href]="item.attachmentsDoc" target="_blank">{{'VIEW_DOC' |
                    translate}}</a>
                </p>
                <ng-template #pdfTemplate>
                  <a style="display: flex; justify-content: center; min-width: 120px"
                    [href]="item.attachmentsDoc ? item.attachmentsDoc : item.ImagePath" target="_blank">
                    View PDF
                  </a>
                </ng-template>
              </span>
            </div>
          </div>

          <div *ngIf="documentList.length > 0" class="field col-12 md:col-12 flex justify-content-center mt-3">
            <button pButton pRipple label="{{ 'SUBMIT' | translate }}" class="p-button-success text-md" style="width: auto;" (click)="onSubmitUpdateDoc()"></button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="d-flex justify-content-center mt-3">
    <div class="field col-12 md:col-12 ">
      <button pButton pRipple label="{{'CLOSE'| translate}}" class="p-button-secondary w-full text-md" (click)="onCloseDocDialog()"></button>
    </div>
  </div>
</p-dialog>